import React from 'react';
import HomeLoanChart from '../ChartCom/HomeLoanChart';
import LoanAgainstPropertyChart from '../ChartCom/LoanAgainstPropertyChart';
import PersonlLoanChart from '../ChartCom/PersonalLoanChart';
import BusinessLoanChart from '../ChartCom/BusinessLoanChart';
import CarLoanChart from '../ChartCom/CarLoanChart';
import Seo from "../components/Seo";

const InterestRatesChart = () => {
  return (
    <>
    <Seo
        title="Loan Interest Rate Chart 2025 — Home, LAP, Car & Education | Mortbuzz"
        description="Compare the latest 2025 interest rate chart for Home Loans, Loan Against Property (LAP), Car Loans and Education Loans. Find lowest rates and top bank offers on Mortbuzz."
        keywords="interest rate chart 2025, home loan interest rates, LAP interest rates, car loan interest rates, education loan interest rates, compare bank rates"
        canonical="https://www.mortbuzz.in/interest-rates-banks"
      />

   
    <HomeLoanChart/>
    <LoanAgainstPropertyChart/>
    <PersonlLoanChart/>
    <BusinessLoanChart/>
    <CarLoanChart/>

    </>
);
};
export default InterestRatesChart;
